import arriereBackoffice, { LeadSource } from '@avantstay/arriere-clients/dist/arriereBackoffice'

interface GetHomeCancellationPoliciesProps {
  homeId: string
  sources: LeadSource[]
}

export const getCancellationPolicyBySources = async (sources: LeadSource[]) => {
  return arriereBackoffice.queries.cancellationPolicyCategories({
    __alias: 'getCancellationPolicyBySources',
    __args: { sources, electableOnly: false },
    description: true,
    id: true,
    name: true,
    items: {
      description: true,
    },
  })
}

export const getHomeCancellationPoliciesBySources = async ({
  homeId,
  sources,
}: GetHomeCancellationPoliciesProps) => {
  return arriereBackoffice.queries.home({
    __alias: 'getHomeCancellationPoliciesBySources',
    __args: { homeId },
    cancellationPolicies: {
      __args: { sources },
      channelCancellationPolicyCategoryId: true,
      description: true,
      name: true,
    },
  })
}

export const getBookingCancellationPolicy = ({ bookingId }: { bookingId: string }) => {
  return arriereBackoffice.queries.bookingCancellationPolicy({
    __alias: 'getBookingCancellationPolicy',
    __args: { bookingId },
    id: true,
  })
}

export const getCouponByCode = ({ code }: { code: string }) => {
  return arriereBackoffice.queries.coupon({
    __alias: 'getCouponByCode',
    __args: { code },
    cancellationPolicyRule: true,
  })
}
